<script setup>
import { computed, toRaw, ref } from 'vue'
import { useLocalizationStore } from '@/stores/localizations.store'
import i18n from '@/plugins/i18n'

const localizationStore = useLocalizationStore()
const t = i18n.global.t

const selectedLanguage = ref(localizationStore.selectedLanguage)

const languages = computed(() => {
  return toRaw(localizationStore.languages).map((item) => {
    return {
      id: item.code,
      name: t(item.name)
    }
  })
})

const onLanguageValueChanged = async() => {
  await localizationStore.setLanguageAsync(selectedLanguage.value)
}

</script>

<template>
  <div class="language-selector">
    <q-select
      v-model="selectedLanguage"
      :options="languages"
      option-label="name"
      option-value="id"
      emit-value
      map-options
      @update:model-value="onLanguageValueChanged"
    />
  </div>
</template>
